import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ProgramFilters from '@ProgramList/components/ProgramFilters.vue';
import { useFormSubmit } from '@ProgramList/composables/useFormSubmit';


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterView',
  setup(__props) {

const { handleFormSubmit } = useFormSubmit();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ProgramFilters, { onSubmit: _unref(handleFormSubmit) }, null, 8 /* PROPS */, ["onSubmit"])
  ]))
}
}

})